import { render, staticRenderFns } from "./DiagramLikeBtn.vue?vue&type=template&id=5e133e74&"
import script from "./DiagramLikeBtn.vue?vue&type=script&lang=ts&"
export * from "./DiagramLikeBtn.vue?vue&type=script&lang=ts&"
import style0 from "./DiagramLikeBtn.vue?vue&type=style&index=0&id=5e133e74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports